var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareProgramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.55 7.35272C23.55 3.7952 20.7005 1 17.0738 1C15.0249 1 13.0585 1.93559 11.775 3.41403C10.4915 1.93559 8.5251 1 6.47625 1C2.84955 1 0 3.7952 0 7.35272C0 8.347 0.207626 9.29937 0.599932 10.241L6.2274 10.2403L8.79288 3.17018L12.8068 12.5504L16.0401 6.25289L17.9313 10.2403L22.9505 10.24C23.3426 9.29857 23.55 8.34659 23.55 7.35272ZM12.628 18.1956L8.96796 9.69125L7.90775 12.5512L1.92321 12.5516C3.66837 14.979 6.50779 17.5046 10.0527 20.6578L10.0677 20.6712L11.775 22.1957L13.4824 20.6826L13.5289 20.6413C17.0596 17.4938 19.8878 14.9729 21.6277 12.5512L16.4054 12.5512L15.9102 11.7917L12.628 18.1956Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareProgramIcon);
export default __webpack_public_path__ + "static/media/CareProgramIcon.2a650ac4722670a765035a519eca2e9f.svg";
export { ForwardRef as ReactComponent };